import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface FeeTypeSelectorProps {
  value?: 'percentage' | 'fixed';
  onChange: (value: 'percentage' | 'fixed') => void;
  idPrefix: string;
}

export const FeeTypeSelector: React.FC<FeeTypeSelectorProps> = ({
  value = 'percentage',
  onChange,
  idPrefix,
}) => {
  return (
    <RadioGroup
      value={value}
      onValueChange={(val) => onChange(val as 'percentage' | 'fixed')}
      className="flex gap-4"
    >
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="percentage" id={`${idPrefix}-type-pct`} />
        <Label htmlFor={`${idPrefix}-type-pct`}>Percentage</Label>
      </div>
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="fixed" id={`${idPrefix}-type-fix`} />
        <Label htmlFor={`${idPrefix}-type-fix`}>Fixed $</Label>
      </div>
    </RadioGroup>
  );
};
